import React, { useEffect, useRef } from "react";


const AnimateIn = ({ children, type = "fadeIn", delay = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;

    const isOnScreen = (el) => {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    };

    const handleScroll = () => {
      if (isOnScreen(element)) {
        element.classList.add("in-view");
      } else {
        element.classList.remove("in-view");
      }
    };

    // Add scroll listener
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    // Initial detection
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`animate ${type}`}
      style={{ transitionDelay: `${delay / 1000}s` }}
    >
      {children}
    </div>
  );
};

export default AnimateIn;
